<template>
	 <div>
		<div class="table-wrap">
			<table border="1" width="100%" style="border-color:#ccc;">
					<tr>
						<th colspan="2">{{order.title}}</th>
						<th>$ {{order.originalprice}}</th>
					</tr>
					<tr>
						<th colspan="2">
							Last:{{order.shapetwoValue}}
						</th>
						<th>$ {{order.shapeprice}}</th>
					</tr>
					<tr>
						<th colspan="2">Version </th>
						<th>{{order.shape}}</th>
					</tr>
					<tr v-for="item in order.size" v-if="item.cate_name && verificationLogo(item.cate_name)">
						<td>{{translate(item.cate_name)}}</td>
						<td>
							{{item.name}}  

							{{showEmbroidery(item.cate_name)}} 


							<div class="colorline" v-if="showEmbroideryIf(item.cate_name)" 
							    :style='"backgroundColor:"+showEmbroideryColor(item.cate_name).color1'>
							</div>

						</td>
						<td>$ {{item.price}}</td>
					</tr>
			</table>
		</div>
		<div class="table-wrap" v-if="order.embroidery.ways.includes(2)">
			<table border="1">
				<tr>
					<th>Position</th>
					<th>Words</th>
					<th>Pictures Color</th>
					<th>Technology</th>
					
				</tr>
				<tr v-if="order.embroidery.ways[0]==2">
					<td>Vamp Logo</td>
					<td>{{order.embroidery.logo1}}</td>
					
					<td>
						<div class="colorline" :style='"backgroundColor:"+order.embroidery.color[0].color1'></div>
					</td>
					<td>{{order.embroidery.technology[0]}}</td>
					
				</tr>
				<tr v-if="order.embroidery.ways[1]==2">
					<td>Lace Cover Logo</td>
					<td>Right：{{order.embroidery.logo2}} -- Left ：{{order.embroidery.logo3}}</td>
					
					<td>
						<div class="colorline" :style='"backgroundColor:"+order.embroidery.color[1].color2' v-if="order.embroidery.diff"></div>
						<div class="colorline" :style='"backgroundColor:"+order.embroidery.color[1].color1'></div>
					</td>
					<td>{{order.embroidery.technology[1]}}</td>
				</tr>
				<tr v-if="order.embroidery.ways[2]==2">
					<td>Heel Logo</td>
					<td>{{order.embroidery.logo4}}</td>
					
					<td>
						<div class="colorline" :style='"backgroundColor:"+order.embroidery.color[2].color1' style="border:1px solid #ccc"></div>
					</td>
					<td>{{order.embroidery.technology[2]}}</td>
					
				</tr>

				<tr v-if="order.embroidery.ways[3]==2">
					<td>领口LOGO</td>
					<td>{{order.embroidery.logo5}}</td>
					<td>
						<div class="colorline" :style='"backgroundColor:"+order.embroidery.color[3].color1'></div>
					</td>
					<td>{{order.embroidery.technology[3]}}</td>
				</tr>
			</table>
		</div>

		<div class="table-wrap" v-if="order.embroidery.ways.includes(3) ">
			<table border="1">
				<tr>
					<th>Position</th>
					<th>Words</th>
					<th>Pictures Color</th>
					<th>Technology</th>
				</tr>

				<tr v-if="order.embroidery.ways[0]==3">
					<td>Vamp Logo</td>

					<td><div class="colorimg" :style='"backgroundImage:url("+getImg(order.embroidery.imageUrlAfter,0)+")"'></div></td>
				    <td>{{getCusPrice(order.embroidery.customImgColor[0])}}</td>
				    <td>{{order.embroidery.technology[0]}} ${{getEmPrice(order.embroidery.technology[0])}}</td>
				</tr>

				<tr v-if="order.embroidery.ways[1]==3">
					<td>Lace Cover Logo</td>
					<td><div class="colorimg" :style='"backgroundImage:url("+getImg(order.embroidery.imageUrlAfter,1)+")"'></div></td>
				    <td>{{getCusPrice(order.embroidery.customImgColor[1])}}</td>
				    <td>{{order.embroidery.technology[1]}} ${{getEmPrice(order.embroidery.technology[1])}}</td>

				</tr>

				<tr v-if="order.embroidery.ways[2]==3">
					<td>Heel Logo</td>
					<td><div class="colorimg" :style='"backgroundImage:url("+getImg(order.embroidery.imageUrlAfter,2)+")"'></div></td>
					<td>{{getCusPrice(order.embroidery.customImgColor[2])}}</td>
					<td>{{order.embroidery.technology[2]}} ${{getEmPrice(order.embroidery.technology[2])}}</td>

				</tr>

				<tr v-if="order.embroidery.ways[3]==3" >
					<td>领口LOGO</td>
					<td><div class="colorimg" :style='"backgroundImage:url("+order.embroidery.imageUrl[3]+")"'></div></td>
					<td>{{getCusPrice(order.embroidery.customImgColor[3])}}</td>
					<td>{{order.embroidery.technology[3]}} ${{getEmPrice(order.embroidery.technology[3])}}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
 export default {
     data() {
			return {
				messageList:[],
			}
		},
		props: ['order',"category"],
		mounted() {
           console.log(this.order)
		},
		methods: {
			getImg(arr,index){
				 var t = "";
             arr.forEach(item=>{
             	item.id==index?t=item.url:""
             })

             return t;
			},
			verificationLogo(text){
				   var flag = true;
               


              switch (text){
					    case "鞋身图案":

					          if(this.order.embroidery.ways[0]==3||this.order.embroidery.ways[0]==2){
					          	  flag = false;
					          }
					        
					        break;
					    case "鞋盖图案":
					          if(this.order.embroidery.ways[1]==3||this.order.embroidery.ways[1]==2){
					          	  flag = false;
					          }
					        
					        break;
					    case "后跟图案":					        
                          if(this.order.embroidery.ways[2]==3||this.order.embroidery.ways[2]==2){
					          	  flag = false;
					          }
					        
					        break;
					    default :
					        
					}

                return flag;
			},
			showEmbroideryColor(text){

	            if(text=="鞋身图案"){
		          	return  this.order.embroidery.color[0]
		         }
		         if(text=="鞋盖图案"){
		          	return  this.order.embroidery.color[1]
		         }
		         if(text=="后跟图案"){
		          	return  this.order.embroidery.color[2]
		         }
		         if(text=="领口图案"){
		          	return  this.order.embroidery.color[3]
		         }
			},
			showEmbroideryIf(text){

                if(text=="鞋身图案"||text=="鞋盖图案"||text=="后跟图案"||text=="领口图案"){
                	return true
                }else{
                	return false
                }
			},
			showEmbroidery(text){


	          if(text=="鞋身图案"){
	          	return  this.order.embroidery.technology[0]
	          }
	          if(text=="鞋盖图案"){
	          	return  this.order.embroidery.technology[1]
	          }
	          if(text=="后跟图案"){
	          	return  this.order.embroidery.technology[2]
	          }
	          if(text=="领口图案"){
	          	return  this.order.embroidery.technology[3]
	          }
			},
          getEmPrice(text){
			   var price = 0;
                if(!text){
               	   return 0;
                }
               this.global_variable.technologyArr.forEach(function(item,b){
               	  if(item.value==text){
               	  	 price = item.price ;
               	  }
               })

               return price
			},
			getCusPrice(text){

			    if(text==1){
			    	return `${this.global_variable.options[0].label}`
			    }else if(text==2){
			    	return `${this.global_variable.options[1].label}`
			    }else if(text==3){
			    	return `${this.global_variable.options[2].label}`
			    }
			    
			},
			translate(e){

				var  text  = e;


                this.category.forEach(function(val, index, arr){
                
				    if(e==val.name){
				    	text = val.remark
				    }
				});

				return text
			},
		}
 }
</script>



<style lang="less">
	.table-wrap{
    	font-size:12px;
    	color:#999;
    	margin-top:10px;
    	line-height:2.4;
    	.colorline{
    		height:10px;
    		width:50px;
    		display:inline-block;
    	}
    	.colorimg{
    		height:50px;
    		width:50px;
    		background-size:cover;
    		display:inline-block;
    		vertical-align: middle;
    		margin:10px 0;
    		background-repeat:no-repeat;
    		background-position: center;
    	}

    	th{
    		text-align:left;
    		padding: 0 20px;
    		font-weight:normal;
    		&:first-child{
    		   color:#90c31f;
    		}
    	}
    	td{
    		padding-left:20px;
    		padding-right:20px;
    		text-align:left;
    		span{
    			vertical-align:baseline;
    		}
    		&:first-child{
    			color:#90c31f;
    			width:20%;
    		}
    	}
    }

    @media screen and (max-width:768px) {
       .table-wrap{
  	      font-size:12px;
  	  		margin-top:10px;
  	  		th,td{
  	  			padding:0;
  	  			text-align:center;
  	  		}
  	  	
  	  	}	
    }
</style>




// WEBPACK FOOTER //
// src/components/custable.vue